import React, { useState } from 'react';
import HamburgerMenu from '../global/menu';
import '../global/styles.css';

function PatientWeightConverter({ userInfo, isAdmin, onLogout, onNavigate }) {
  const [weightInput, setWeightInput] = useState('');
  const [unit, setUnit] = useState('lbsToKg');
  const [result, setResult] = useState('---');

  const handleConvert = () => {
    const weight = parseFloat(weightInput);

    // Validate Input
    if (isNaN(weight) || weight <= 0) {
      setResult('Please enter a valid positive number');
      return;
    }

    // Conversion Logic
    let convertedValue;
    if (unit === 'lbsToKg') {
      convertedValue = (weight / 2.20462).toFixed(2) + ' kg';
    } else if (unit === 'kgToLbs') {
      convertedValue = (weight * 2.20462).toFixed(2) + ' lbs';
    }

    setResult(convertedValue);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConvert();
    }
  };

  return (
    <div className="container-center" style={{ paddingBottom: '80px' }}>
      {/* Hamburger Menu */}
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div className="card card-center" style={{
        maxWidth: '600px',
        width: '100%',
        padding: '50px 40px'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '40px',
          borderBottom: '2px solid #0E3293',
          paddingBottom: '25px'
        }}>
          <h2 style={{
            fontSize: '32px',
            fontWeight: 'bold',
            color: '#0E3293',
            margin: '0 0 15px 0',
            letterSpacing: '-0.5px'
          }}>
            Patient Weight Converter
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#777',
            margin: '0',
            lineHeight: '1.6'
          }}>
            Convert weight between pounds (lbs) and kilograms (kg)
          </p>
        </div>

        {/* Calculator Section */}
        <div style={{
          background: '#f8f9fa',
          padding: '30px',
          borderRadius: '12px',
          marginBottom: '20px',
          boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
        }}>
          {/* Input Field */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '500',
              color: '#333',
              fontSize: '15px'
            }}>
              Enter Weight:
            </label>
            <input
              type="number"
              value={weightInput}
              onChange={(e) => setWeightInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter weight"
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '16px',
                transition: 'border-color 0.2s ease',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = '#0E3293'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>

          {/* Unit Selector */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '500',
              color: '#333',
              fontSize: '15px'
            }}>
              Conversion Type:
            </label>
            <select
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '16px',
                backgroundColor: 'white',
                cursor: 'pointer',
                outline: 'none'
              }}
            >
              <option value="lbsToKg">Pounds to Kilograms</option>
              <option value="kgToLbs">Kilograms to Pounds</option>
            </select>
          </div>

          {/* Convert Button */}
          <button
            onClick={handleConvert}
            className="btn btn-primary btn-full"
            style={{
              background: '#0E3293',
              borderColor: '#0E3293',
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '20px'
            }}
          >
            Convert
          </button>

          {/* Result Display */}
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            border: '2px solid #e0e0e0',
            textAlign: 'center'
          }}>
            <p style={{
              margin: '0 0 8px 0',
              fontSize: '14px',
              color: '#666',
              fontWeight: '500'
            }}>
              Result:
            </p>
            <span style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: result.includes('Please') ? '#c62828' : '#0E3293'
            }}>
              {result}
            </span>
          </div>
        </div>

        {/* Disclaimer */}
        <p style={{
          textAlign: 'center',
          fontSize: '13px',
          color: '#999',
          fontStyle: 'italic',
          margin: '0'
        }}>
          2.2205 is used for the kilogram conversion factor
        </p>
      </div>

      {/* Fixed Footer */}
      <footer style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        background: '#ffffff',
        textAlign: 'center',
        padding: '15px 10px',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.08)',
        zIndex: 9999,
        borderTop: '1px solid #e0e0e0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          <img
            src="https://us.api.fliplet.com/v1/media/files/5174683/contents/blob"
            alt="NarcoticTrack Logo"
            style={{
              height: '32px',
              verticalAlign: 'middle'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: '#666',
            fontWeight: '400'
          }}>
            © 2025 NarcoticTrack Inventory System, LLC
          </span>
        </div>
      </footer>
    </div>
  );
}

export default PatientWeightConverter;
